// http://testexam.ipmph.com/zas3/oauth/authorize?client_id=130a615d7aeb4ac68902ca5a4e793a33&response_type=code&scope=user_info&redirect_uri=http://192.168.42.145/auth/single/loginCode
import { stringify } from "qs";
import { setRedirectUrl, clearToken } from "@/utils/token";
import qs from "qs";

const VUE_APP_RedirectURL = process.env.VUE_APP_RedirectURL;
const VUE_APP_SSO_URL = process.env.VUE_APP_SSO_URL;

/**
 * 登录
 */
export function handleSSOLogin(route) {
  setRedirectUrl(encodeURIComponent(window.parent.location.href));
  let currentUrl = encodeURIComponent(window.parent.location.href);
  if (route) {
    if (route.params || route.query) {
      setRedirectUrl(
        encodeURIComponent(
          `${VUE_APP_RedirectURL}${route.path}?${qs.stringify(
            route.query || route.params
          )}`
        )
      );
      currentUrl = encodeURIComponent(
        `${VUE_APP_RedirectURL}${route.path}?${qs.stringify(
          route.query || route.params
        )}`
      );
    } else {
      setRedirectUrl(encodeURIComponent(`${VUE_APP_RedirectURL}${route.path}`));
      currentUrl = encodeURIComponent(`${VUE_APP_RedirectURL}${route.path}`);
    }
  } else {
    if (document) {
      setRedirectUrl(encodeURIComponent(window.parent.location.href));
      currentUrl = encodeURIComponent(window.parent.location.href);
    }
  }
  const params = {
    client_id: process.env.VUE_APP_ClientID,
    response_type: "code",
    scope: "user_info",
    redirect_uri: `${VUE_APP_RedirectURL}?Referer=${currentUrl}`,
  };
  const loginUrl = `${VUE_APP_SSO_URL}/oauth/authorize?${stringify(params)}`;
  parent.location.href = loginUrl;
}

// 注册

export function handleSSORegister(route) {
  setRedirectUrl(encodeURIComponent(window.parent.location.href));
  let currentUrl = encodeURIComponent(window.parent.location.href);
  if (route) {
    if (route.params || route.query) {
      setRedirectUrl(
        encodeURIComponent(
          `${VUE_APP_RedirectURL}${route.path}?${qs.stringify(
            route.query || route.params
          )}`
        )
      );
      currentUrl = encodeURIComponent(
        `${VUE_APP_RedirectURL}${route.path}?${qs.stringify(
          route.query || route.params
        )}`
      );
    } else {
      setRedirectUrl(encodeURIComponent(`${VUE_APP_RedirectURL}${route.path}`));
      currentUrl = encodeURIComponent(`${VUE_APP_RedirectURL}${route.path}`);
    }
  } else {
    if (document) {
      setRedirectUrl(encodeURIComponent(window.parent.location.href));
      currentUrl = encodeURIComponent(window.parent.location.href);
    }
  }
  const params = {
    client_id: process.env.VUE_APP_ClientID,
    response_type: "code",
    scope: "user_info",
    redirect_uri: `${VUE_APP_RedirectURL}?Referer=${currentUrl}`,
  };
  const loginUrl = `${VUE_APP_SSO_URL}/pmph/regist.html?${stringify(params)}`;
  parent.location.href = loginUrl;
}

/**
 * 清除所有cookie函数
 */
export function handlClearLoginInfo() {
  clearToken();
}
